module.exports = "/images/image3.jpg?0d703214f2011cb30a4ef71a241f5f59";